module.exports = __webpack_public_path__ + "static/media/downArrow.ade213cc.svg";